import { periodFormat } from 'utils/common';
import { initialTableShow } from 'utils/settings';

export const createReqBody = (
  date,
  type,
  person,
  fromTo,
  fieldName,
  direction,
  customerId
) => {
  return {
    filters: {
      customerId: customerId,
      createdPeriod: periodFormat(date),
      activityType: type?.[0] ? type : '*',
      arr: {
        from: fromTo?.arrChangedFrom ? +fromTo.arrChangedFrom : '*',
        to: fromTo?.arrChangedTo ? +fromTo.arrChangedTo : '*'
      }
    },
    sort: {
      fieldName: fieldName,
      direction: direction
    }
  };
};

export const createSaveList = location => {
  let loadList;
  const query = new URLSearchParams(location.search);
  loadList = {
    fromTo: JSON.parse(query.get('fromTo')),
    type: query?.get('type') + '' !== '' ? query?.get('type')?.split(',') : [],
    person:
      query?.get('person') + '' !== '' ? query?.get('person')?.split(',') : [],
    date:
      query?.get('start') + '' !== 'null'
        ? {
            startDate: query?.get('start'),
            endDate: query?.get('end')
          }
        : { startDate: null, endDate: null },
    direction:
      query?.get('direction') + '' !== 'null'
        ? Number(query?.get('direction'))
        : initialTableShow.direction * -1,
    currentPage:
      query?.get('currentPage') + '' !== 'null'
        ? Number(query?.get('currentPage'))
        : initialTableShow.currentPage,
    itemsPerPage:
      query?.get('itemsPerPage') + '' !== 'null'
        ? Number(query?.get('itemsPerPage'))
        : initialTableShow.itemsPerPage,
    fieldName:
      query?.get('fieldName') + '' !== 'null'
        ? query?.get('fieldName')
        : 'createdDate'
  };
  return loadList;
};
